import { useGetLabelQuery } from 'generated/graphql';
import { useMemo } from 'react';
import { EntityLabel, ReasonLabel } from 'v2/core/entities/labels';
import { mapLabelData } from 'v2/core/repository/edge-server/labels/mappers';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { EdgeResponse } from 'v2/core/repository/edge-server/types';
import { UseGetLabelInput } from '../types/label';

const useGetLabel = (
  input: UseGetLabelInput,
): EdgeResponse<EntityLabel | ReasonLabel> => {
  const {
    data: eData,
    loading,
    error,
    called,
    refetch,
  } = useGetLabelQuery({
    variables: input,
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  const data = useMemo(
    () => (eData?.getLabelByID ? mapLabelData(eData?.getLabelByID) : undefined),
    [eData?.getLabelByID],
  );

  return {
    data,
    error,
    status,
    refetch,
  };
};

export default useGetLabel;
